import classNames from "classnames";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { EventsState } from "../../../../../store/types";
import { getDefaultAgendaImage } from "../../../../../store/utils/create-event";
import { TemplateClassNames } from "../../../../../types/template-layouts";
import { PageModule } from "../../../../../types/working-model";
import SessionCard from "../../../modules/agenda/agenda-session-card";
import { getStylingOverrides } from "../../../utils";

import '../../../../live-event/modules/agenda/agenda.scss';
import { TypographyItem } from "../../../../general-ui/typography-item/typography-item";
import { ParamsProps } from "../../../live-event";
import { useParams } from "react-router";
import { getTextValue } from "../../../../../utils/utils";

import "./similar-sessions.scss";
import { useTranslation } from "react-i18next";

interface SimilarSessionsProps {
	module: PageModule;
	template: TemplateClassNames;
}
const SessionSimilarSessions: React.FC<SimilarSessionsProps> = ({ template, module }) => {
	const {
		LiveEventReducer: {
			eventBundle
		},
	} = useSelector((event: EventsState) => event);
	const params: ParamsProps = useParams();
	const language = params?.language || 'en';
	const { t } = useTranslation("session");

	const selectedSessionIds = module.content_modules;
	const sessions = useMemo(() => {
		return eventBundle?.sessions.filter(session => selectedSessionIds?.includes(session.session));
	}, [selectedSessionIds, eventBundle]);

	const stylingOverrides = getStylingOverrides(module.styling_overrides);

	const cardStyling = sessions?.length === 1 ? "agenda-standard" : "agenda-vertical_card";

	const { custom_heading } = getTextValue(module.content, language);
	if (!sessions || !sessions.length) return null;
	return (
		//needs "agenda", "agenda-sessions-list" and the cardStyling classnames to access the session card styling
		<div
			className={classNames(
				"session-module similar-sessions agenda",
				cardStyling,
				stylingOverrides.backgroundColor,
				template
			)}
			style={stylingOverrides.backgroundImg}
		>
			<TypographyItem
				tagName="h5"
				template={template}
				className={classNames(
					"similar-sesison-custom_heading evt-heading-5",
					stylingOverrides.customHeadingOverrides
				)}>
				{custom_heading || t("Similar Sessions")}
			</TypographyItem>
			<div className="agenda-sessions-list">
				{
					sessions?.map((session, i) => (
						<SessionCard
							defaultImage={getDefaultAgendaImage(template, i)}
							template={template}
							key={session.session}
							session={session}
							stylingOverrides={stylingOverrides}
						/>
					))
				}
			</div>
		</div>
	);
};

export default SessionSimilarSessions;